import { Component, OnInit, Input } from '@angular/core';
import { BillingFormComponent } from 'ngx-intellforce-billing/lib/components/billing-form/billing-form.component';

@Component({
  selector: 'app-ccpa',
  templateUrl: './ccpa.component.html',
  styleUrls: ['./ccpa.component.scss']
})
export class CcpaComponent implements OnInit {

  @Input() form: BillingFormComponent;
  constructor() { }

  currentyear: any;
  ngOnInit(): void {
    this.currentyear = new Date();
    this.currentyear.setDate(new Date().getDate());
  }

}
